import styled from 'styled-components';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
// This is a component that is used to display the content of an email, and it does not make sense to tokenize it.
export const ContentOverrides = styled.div.withConfig({
  displayName: "ContentText__ContentOverrides",
  componentId: "sc-1sq2pdv-0"
})(["word-wrap:break-word;overflow-x:auto;white-space:", ";line-height:1.5;img{max-width:100%;height:auto;}.display-none{display:none;}[data-hs-linktype='hs-customer-agent-email-feedback-buttons']{display:none;}h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:bold;}pre{overflow:visible;}math[display='block']{padding:8px 0;}"], ({
  isPlainText
}) => isPlainText && 'pre-wrap');
const ContentText = ({
  contentText,
  isPlainText = false,
  isShowingMessageReplies,
  dataTestId = 'primary-message-content'
}) => {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(ContentOverrides, {
      isPlainText: isPlainText,
      children: /*#__PURE__*/_jsx(SanitizedText, {
        body: contentText,
        textSeleniumKey: dataTestId,
        formattingOptions: {
          isPlainText,
          shouldRemoveGmailLineBreakBeforeReply: true,
          shouldRemoveEmailSignature: !isShowingMessageReplies,
          shouldIncludeReplies: isShowingMessageReplies,
          shouldOpenLinksInNewTab: true,
          shouldPreserveMathML: true
        }
      })
    })
  );
};
ContentText.propTypes = {
  contentText: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  isPlainText: PropTypes.bool,
  isShowingMessageReplies: PropTypes.bool
};
ContentText.displayName = 'ContentText';
export default ContentText;